import { render, staticRenderFns } from "./CharacterEditPage.vue?vue&type=template&id=96485556&scoped=true&"
import script from "./CharacterEditPage.vue?vue&type=script&lang=ts&"
export * from "./CharacterEditPage.vue?vue&type=script&lang=ts&"
import style0 from "./CharacterEditPage.vue?vue&type=style&index=0&id=96485556&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96485556",
  null
  
)

export default component.exports